import { render, staticRenderFns } from "./NewTaskDlg.vue?vue&type=template&id=9c51fcdc&scoped=true"
import script from "./NewTaskDlg.vue?vue&type=script&lang=js"
export * from "./NewTaskDlg.vue?vue&type=script&lang=js"
import style0 from "./NewTaskDlg.vue?vue&type=style&index=0&id=9c51fcdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c51fcdc",
  null
  
)

export default component.exports